import { LINE_SPACING_TYPE as type } from "./types";
const DEFAULTS = Object.freeze({
  type,
  config: {}
});
const DEFAULT_LINE_SPACING = {
  "line-height": "1.5",
  "padding-top": "0px",
  "padding-bottom": "0px"
};
export {
  DEFAULTS,
  DEFAULT_LINE_SPACING
};
//# sourceMappingURL=defaults.js.map
